import { render, staticRenderFns } from "./PricingForSpecialGroupsCard.vue?vue&type=template&id=74832e15&scoped=true"
import script from "./PricingForSpecialGroupsCard.vue?vue&type=script&lang=js"
export * from "./PricingForSpecialGroupsCard.vue?vue&type=script&lang=js"
import style0 from "./PricingForSpecialGroupsCard.vue?vue&type=style&index=0&id=74832e15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74832e15",
  null
  
)

export default component.exports